
import * as React from "react"
import { useDevice } from "@/contexts/DeviceContext"

export function useIsMobile() {
  return useDevice().isMobile
}

export function useIsTablet() {
  return useDevice().isTablet
}

export function useDeviceCapabilities() {
  const { hasTouchScreen, isReducedMotion, isMobileDevice, isLandscape, isPortrait } = useDevice()

  return React.useMemo(
    () => ({ hasTouchScreen, isReducedMotion, isMobileDevice, isLandscape, isPortrait }),
    [hasTouchScreen, isReducedMotion, isMobileDevice, isLandscape, isPortrait]
  )
}

// New hook for responsive values based on screen size
export function useResponsiveValue<T>(
  mobileValue: T, 
  tabletValue: T, 
  desktopValue: T
): T {
  const { isMobile, isTablet } = useDevice();
  
  if (isMobile) return mobileValue;
  if (isTablet) return tabletValue;
  return desktopValue;
}
